import { WidgetStreamStreamingConfig } from 'widgets/streaming/WidgetStreamConfig';
import { clearOpenSubmissionsStreamData } from 'widgets/openSubmissions/store/stream/actions';
import { selectStreamKey } from 'widgets/openSubmissions/store/stream/selectors';
import { OpenSubmissionsElement } from 'communication/types/openSubmissions/OpenSubmissionsElement';
import { createOrderIdsStreamRequest } from 'widgets/streaming/OrderIdsStreamRequest';
import { OrderIdsStreamRequest } from 'communication/types/order/OrderIdsStreamRequest';
import { WidgetType } from 'widgets/WidgetType';

export const openSubmissionsWidgetStreamConfig: WidgetStreamStreamingConfig<
    OrderIdsStreamRequest,
    OpenSubmissionsElement
> = {
    configType: 'OrderIdsDependentWidgetStreamConfig',
    streamType: 'StreamingStream',
    startChannelDestination: 'startOpenSubmissionsByOrderIdsStream',
    createPayload: createOrderIdsStreamRequest,
    selectWidgetStreamKey: selectStreamKey,
    clearWidgetStreamData: clearOpenSubmissionsStreamData(
        WidgetType.OPEN_SUBMISSIONS
    ),
};
